import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IModalWindowData } from '../interfaces/interfaces';

@Component({
  selector: 'app-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss']
})
export class ModalWrapperComponent implements OnInit {  
  constructor(
    public dialogRef: MatDialogRef<ModalWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IModalWindowData,
  ) {}

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef?.close();
  }
}

